import Page from 'component/Page';
import React from 'react';
import string from 'util/string';
import Table from 'component/Table';
const Links = () => {
    const data = [
        {
            id: 0,
            title: "アルインコ インカムショップ（プリペイド購入）",
            link: "https://alinco-incom.com/SHOP/Q004-002.html",
        },
        {
            id: 1,
            title: "Air-InCom.Lite総合案内",
            link: "https://alinco-denshi.com/item/cat40/air-incomlite.html",
        },
        {
            id: 2,
            title: "マイページマニュアル",
            link: "https://alinco-denshi.com/item/uploads/Air-InComLite_consolemanual.pdf",
        },
        {
            id: 3,
            title: "アプリ操作マニュアル",
            link: "https://alinco-denshi.com/item/uploads/PW0006B_Air-InComLite_manual%20.pdf",
            // link: "https://alinco-denshi.com/item/uploads/PW0006_Air-InComLite_manual.pdf",
        },
        {
            id: 4,
            title: "アプリ操作マニュアル（詳細）",
            link: "https://alinco-denshi.com/item/uploads/PW0005B_Air-InComLite_detail_manual%20.pdf",
            // link: "https://alinco-denshi.com/item/uploads/PW0005_Air-InComLite_detail%20manual.pdf",
        },
        {
            id: 5,
            title: "申込用紙",
            link: "https://alinco-denshi.com/item/uploads/Air-InComLite_entrysheet.pdf",
        },
        {
            id: 6,
            title: "口座振替用紙",
            link: "https://alinco-denshi.com/item/uploads/PF0405_kouzahurikae.pdf",
        },
        {
            id: 7,
            title: "口座振替用紙送付用封筒",
            link: "https://alinco-denshi.com/item/uploads/Air-InComLit_hutou20231221.pdf",
        },
    ];


    return (
        <Page
            title={string.APP_LINKS}
            body={
                <Table
                    className="nowrap"
                    headers={''}
                    data={data.map(item => (
                        {
                            data: [ <a key={item.id} href={item.link} target="_blank" rel="noreferrer">{item.title}</a> ]
                        }
                    ))}
                    c
                    isPaging={false}
                />
            }
        />
    );
};
export default Links;
